import SeedLabel from "../SeedLabels/SeedLabel";

export default class SeedLabelStatistics {
  SeedLabel: SeedLabel = new SeedLabel();
  Planted = 0;
  Germinated = 0;
}
